export const ADD_LOTS = 'ADD_LOTS'
export const ADD_LOT = 'ADD_LOT'
